import { render, staticRenderFns } from "./DepartmentEditComponent.vue?vue&type=template&id=5c25acb3"
import script from "./DepartmentEditComponent.vue?vue&type=script&lang=js"
export * from "./DepartmentEditComponent.vue?vue&type=script&lang=js"
import style0 from "./DepartmentEditComponent.vue?vue&type=style&index=0&id=5c25acb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports